import React from 'react';

import css from './CityList.module.css';

const CityList = props => {
  const { cities } = props;
  return (
    <React.Fragment>
      <div className={css.cityList}>
        {cities.map(city => {
          return (
            <div className={css.city} key={city.url}>
              <a href={city.url} className={css.link}>
                <h3>{city.title}</h3>
                <span>{`${city.listing_count} Listings`}</span>
              </a>
            </div>
          );
        })}
      </div>
    </React.Fragment>
  );
};

export default CityList;
